import React, {useRef, useState} from 'react';
import { useField } from '@unform/core';
import PropTypes from 'prop-types';

import {Checkbox, FormControlLabel} from "@material-ui/core";
import CheckBoxOutlineBlank from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBox from "@material-ui/icons/CheckBox";

/** Checkbox visível no fundo escuro: borda laranja vazia, preenchido laranja ao marcar (evita azul do `color="primary"`). */
function CheckboxDark(props) {
    const iconStyle = { color: "rgba(242, 146, 5, 0.92)", fontSize: 26 };
    const checkedStyle = { color: "#f29205", fontSize: 26 };
    return (
        <Checkbox
            {...props}
            color="default"
            style={{ padding: 9, ...props.style }}
            icon={<CheckBoxOutlineBlank style={iconStyle} />}
            checkedIcon={<CheckBox style={checkedStyle} />}
        />
    );
}

function CkeckboxInput({
    name,
    value,
    options,
    setValue,
    labelLight,
    /** ex.: col-12 col-md-4 — mobile em coluna única, desktop em grelha */
    optionColClass = 'col-6',
    ...props
}) {
    const { fieldName, registerField, defaultValue } = useField(name);
    const inputRef = useRef(null)
    const formGroupRef = useRef(null)
    const [valueChecked, setValueChecked] = useState(value);

    React.useEffect(() => {
        registerField({
            name: fieldName,
            ref: inputRef.current,
            path: 'value',
        });
    }, [fieldName, registerField]);

    React.useEffect(() => {
        setValue(valueChecked)
    }, [valueChecked]);

    React.useEffect(() => {
        registerField({
            name: fieldName,
            ref: inputRef.current,
            clearValue: (refs) => {
                refs.forEach(ref => {
                    ref.checked = false;
                });
            },
            setValue: (refs, values) => {
                refs.forEach(ref => {
                    if (values.includes(ref.id)) {
                        ref.checked = true;
                    }
                });
            }
        });
    }, [defaultValue, fieldName, registerField]);

    return (
        <>
            <div ref={formGroupRef} className="row">
                {options.length
                    ? options.map((option, index) => {
                          const Cb = labelLight ? CheckboxDark : Checkbox;
                          const labelStyle = {
                              color: labelLight ? '#ffffff' : 'rgba(0, 0, 0, 0.6)',
                              lineHeight: 1.25,
                          };
                          const labelRootStyle = labelLight
                              ? {
                                    alignItems: 'center',
                                    marginLeft: 0,
                                    marginRight: 0,
                                    width: '100%',
                                }
                              : undefined;
                          return (
                              <div className={optionColClass} key={index}>
                                  <FormControlLabel
                                      style={labelRootStyle}
                                      label={
                                          <span style={labelStyle}>
                                              {option.label}
                                          </span>
                                      }
                                      control={
                                          <Cb
                                              checked={valueChecked === option.value}
                                              onChange={(e) => setValueChecked(e.target.value)}
                                              name={option.name}
                                              inputRef={inputRef}
                                              value={option.value}
                                              style={
                                                  labelLight
                                                      ? {
                                                            padding: '4px 10px 4px 4px',
                                                        }
                                                      : undefined
                                              }
                                              {...props}
                                          />
                                      }
                                  />
                              </div>
                          );
                      })
                    : null}
            </div>
        </>
    )
}

export default CkeckboxInput;

CkeckboxInput.propTypes = {
    name: PropTypes.string.isRequired,
    labelLight: PropTypes.bool,
    optionColClass: PropTypes.string,
};

